/* cspell: disable*/
import React from 'react';
import './service-charge.less';
import { Theme } from '@theme';
import { WithCoreProps, TranslationProps } from 'ff-shared-components-core';
import {
	Button,
	TitleContainer,
	InputField,
	FileField,
	FileUploadType,
	TemporaryFile,
	FileAction,
	modalOpen,
	BuildOkInfoModal,
	Modal,
	TitleContainer2,
	FieldsFormContainer,
	PageScreen,
} from '@shared/components';
import { Formik, FormikValues, Form, Field, FormikErrors } from 'formik';
import {
	StoreState,
	getRegisterPharmacyInputData,
	RegisterInputData,
	fetchUploadFileExecutionRequest,
	removeUploadFileExecution,
	saveTransferInputData,
	StepRegisterInputData,
} from '@store';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { ProcessFlowState, getProcessFlow } from '@shared/processFlow';
import { EnrollmentTypes } from '@api/ff-shared-services-api';
import { serviceChargeSchema } from '@components';
import { FileUploadConfig } from '@config';

export type ServiceChargeType = {
	ibanNumber: string;
	ibanProofFile: FileUploadType;
};

interface ServiceChargeState {
	selectedAccountId: number;
}

export interface ServiceChargeInnerProps {
	registerInputData: RegisterInputData;
	fetchUploadFileExecutionRequest: (fileData: FileUploadType) => void;
	removeUploadFileExecution: (currentStep: number) => void;
	saveTransferInputData: (registerInputData: RegisterInputData, stepIndex: number) => void;
	modalOpen: (modal: Modal) => void;
	processFlow: ProcessFlowState;
}

interface ServiceChargeProps {
	onClickNext(data: StepRegisterInputData): void;
	onClickBack(data: any): void;
	onClickCancel(): void;
}

interface ServiceChargeInjectedProps extends TranslationProps {
	a: Theme;
}

type Props = ServiceChargeProps & ServiceChargeInjectedProps;

class ServiceChargeScreen extends React.PureComponent<Props & ServiceChargeInnerProps, ServiceChargeState> {
	public constructor(props: Props & ServiceChargeInnerProps) {
		super(props);
		window.scrollTo(0, 0);
	}

	public render(): JSX.Element {
		const {
			t,
			onClickNext,
			onClickBack,
			modalOpen,
			onClickCancel,
			registerInputData,
			saveTransferInputData,
		} = this.props;

		const storeCurrentRegisterFile = registerInputData.ibanInputFile ? registerInputData.ibanInputFile : null;

		return (
			// <div id="page-service-charge" className="page-service-charge">
			// 	<div className="registerPharmacy-container service-charge-container top-88px">
			<PageScreen name="page-service-charge">
				<FieldsFormContainer>
					<TitleContainer2 text={t('titleContainer.service-charge.title')}>
						<div className="bottom-88px">
							{/* <span className="service-charge-description"> */}
							<span className="descriptions">{t('titleContainer.service-charge.description')}</span>
						</div>
						<Formik
							initialValues={{
								ibanNumber: registerInputData.ibanNumber ? registerInputData.ibanNumber : '',
								ibanProofFile: {
									id: '',
									name:
										registerInputData && storeCurrentRegisterFile
											? storeCurrentRegisterFile.fileName
											: '',
									type: '',
									base64File: '',
								},
							}}
							validationSchema={serviceChargeSchema({ t })}
							onSubmit={(values: ServiceChargeType, { setSubmitting }): void => {
								const { ibanNumber, ibanProofFile } = values;

								const stepInputData: StepRegisterInputData = {
									stepIndex: 2,
									registerInputData: {
										ibanNumber,
									},
								};

								/* MOCK_DATA - START */
								// const stepInputData: RegisterInputData = {
								// 	ibanNumber: 'PT50 0002 0123 1234 5678 9015 4',
								// };
								/* MOCK_DATA - END */

								saveTransferInputData &&
									saveTransferInputData(stepInputData.registerInputData as RegisterInputData, 2);
								setSubmitting(false);
								onClickNext(stepInputData);
							}}
						>
							{({ isSubmitting, getFieldMeta, setFieldValue, validateForm, values }): FormikValues => (
								<Form>
									<Field
										component={InputField}
										inputType="text"
										name="ibanNumber"
										isRequired
										inputFieldLabel={t<string>('titleContainer.service-charge.label.iban-number')}
										hasError={getFieldMeta('ibanNumber').error}
										errorMessage={getFieldMeta('ibanNumber').error}
										onChange={(event: React.ChangeEvent<HTMLTextAreaElement>): void => {
											setFieldValue('ibanNumber', event.target.value, false);
										}}
										defaultValue={registerInputData.ibanNumber}
									/>
									<Field
										component={FileField}
										name="ibanProofFile"
										isRequired
										buttonText={t<string>('buttons.general.select')}
										nrAllowedFiles={1}
										fileFieldLabel={t<string>(
											'titleContainer.service-charge.label.iban-proof-file'
										)}
										filesList={
											registerInputData && storeCurrentRegisterFile
												? [
														{
															id: '',
															name: storeCurrentRegisterFile.fileName,
														},
												  ]
												: undefined
										}
										filesMaxSize={FileUploadConfig.maxFileSizeBytes}
										showAttachmentSizeInfoModal={(text: string): void => {
											modalOpen(
												BuildOkInfoModal(
													t(text, {
														maxSize: FileUploadConfig.maxFileSizeMegaBytes,
													}),
													'Ok'
												)
											);
										}}
										showAttachmentsNumberInfoModal={(text: string): void => {
											modalOpen(BuildOkInfoModal(t(text, { maxNumber: 1 }), 'Ok'));
										}}
										fileId={1}
										handleFile={(file: TemporaryFile, action: FileAction): void => {
											// handle our handle change with all info and formik setFieldValue
											this.handleFileChange(
												file,
												action,
												values.ibanProofFile,
												'ibanProofFile',
												setFieldValue
											);
										}}
										hasError={getFieldMeta('ibanProofFile').error}
										errorMessage={t('errors.form.required')}
									/>
									<div className="bottom-buttons bottom-88px">
										<Button
											primary
											type="submit"
											onClick={(): any => {
												return validateForm().then(
													(errors: FormikErrors<ServiceChargeType>) =>
														Object.keys(errors).length === 0
												);
											}}
											text={t<string>('buttons.general.next')}
											disabled={isSubmitting}
										/>
										{/* <Button
											tertiary
											onClick={onClickCancel}
											text={t<string>('buttons.general.cancel')}
										/> */}

										<Button
											tertiary
											text={t('general.button.cancel')}
											onClick={event => {
												event.preventDefault();
												onClickCancel();
											}}
										/>
										<Button
											tertiary
											onClick={event => {
												event.preventDefault();
												onClickBack(undefined);
											}}
											text={t<string>('buttons.general.back')}
										/>
									</div>
								</Form>
							)}
						</Formik>
					</TitleContainer2>
				</FieldsFormContainer>
				{/* </div>
			</div> */}
			</PageScreen>
		);
	}

	/**
	 * Method handle the response from file chooser component and sets value to formik setFieldValue()
	 *
	 * @memberof ServiceChargeScreen
	 */

	private handleFileChange = (
		file: TemporaryFile,
		action: FileAction,
		currentFile: FileUploadType,
		fieldName: string,
		setFormikInputValue: (field: string, value: FileUploadType, shouldValidate?: boolean) => void
	): void => {
		if (action === FileAction.Add) {
			if (!file.error) {
				const { fetchUploadFileExecutionRequest } = this.props;

				currentFile = {
					id: file.id,
					name: file.file.name,
					type: file.file.type,
					base64File: file.base64File,
					inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.IBAN.toString(),
				};

				const { type, base64File } = currentFile;
				if (type && base64File) {
					fetchUploadFileExecutionRequest(currentFile);
				}
			}
		} else if (action === FileAction.Remove) {
			currentFile = {
				id: '',
				name: '',
				type: '',
				base64File: '',
			};
		}

		// Only has 1 file
		setFormikInputValue(fieldName, currentFile, false);
	};
}

const mapStateToProps = (state: StoreState): object => ({
	registerInputData: getRegisterPharmacyInputData(state),
	processFlow: getProcessFlow(state),
});
const mapDispatchToProps = (dispatch: any): object =>
	bindActionCreators(
		{
			fetchUploadFileExecutionRequest,
			removeUploadFileExecution,
			saveTransferInputData,
			modalOpen,
		},
		dispatch
	);

export default WithCoreProps<ServiceChargeProps>(connect(mapStateToProps, mapDispatchToProps)(ServiceChargeScreen));
